<section class="notification__header">
    @if (true) {
        <div class="notification__icon">
            <mat-icon class="{{ contextClass }}">{{ contextIcon }}</mat-icon>
        </div>
    } @else {
        <div class="notification__pulsing-icon">
            <sphere-pulsing-indicator color="accent" animation="pulse" size="medium"></sphere-pulsing-indicator>
        </div>
    }
    <div class="notification__title-wrapper">
        <div class="notification__title" [title]="notification.title">{{ notification.title }}</div>
        <div class="notification__timestamp text-subtle">{{ formatTimestamp(notification.timestamp) }}</div>
    </div>
    <div class="notification__close">
        <mat-icon (click)="dismissVisible()">close</mat-icon>
    </div>
</section>
<section class="notification__body">
    @if (notification.app) {
        <p class="notification__app text-subtle">
            <small>{{ notification.app | uppercase }}</small>
        </p>
    }
    <p class="notification__content">{{ notification.content }}</p>
</section>
@if (notification.url) {
    <section class="notification__actions">
        <a mat-button (click)="dismissVisible(); markAsRead()" [routerLink]="notification?.url">OPEN</a>
    </section>
}
@if (isInProgress) {
    <section class="notification__progress">
        <mat-progress-bar mode="indeterminate" [style.height]="'1px !important'" color="accent"></mat-progress-bar>
    </section>
}
